export const STORE_BASIC_EVENTS = 'basicEventsStore';
export const STORE_EVENTS = 'event';
export const STORE_EVENT_CALENDAR = 'event-calendar';

export const BE_SET_OPTIONS = 'setOptions';
export const BE_SET_SETTING = 'setSetting';

export const BE_DEFAULT_SHOW_DAYS = 3;
